// extracted by mini-css-extract-plugin
export default {"primary-text":"qa-service-details_primary-text__pTSF7","info-section-title":"qa-service-details_info-section-title__X3Cv-"};